/**
 * Global Imports
*/

import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

/**
 * Root Imports
*/

import { CssClassName } from '~/util/Css';

/**
 * Local Imports
*/

import { LabeledField } from './LabeledField';

/**
 * Exports
*/

/**
 * 
 */
export function Select(props) {
  /** Settings **/

  const config = {
    name: props.name,
    className: CssClassName(props.elementClassName),
    onChange: !props.disabled ? props.onChange : undefined
  };

  /** Output **/

  return (
    <LabeledField { ...props }>
      {
        React.cloneElement(props.elementWrapper, {
          children: <select { ...config }>{ props.children }</select>
        })
      }
    </LabeledField>
  );
}

Select.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.oneOfType([ PropTypes.string, PropTypes.array ]),
  elementWrapper: PropTypes.oneOfType([ PropTypes.node, PropTypes.func ]),
  formik: PropTypes.object
};

Select.defaultProps = {
  elementWrapper: <Fragment/>
};